<template>
  <div class="timer">
    <!-- <div class="btn-timer">
      <el-button style="padding: 3px" size="mini" :type="isTimer ? 'danger' : 'primary'" @click="switchTimer">
        <i style="font-size: large" :class="isTimer ? 'el-icon-video-pause' : 'el-icon-video-play'"></i>
      </el-button>
      <el-button size="mini" id="reset" @click="reset">重置</el-button>
    </div> -->
    <div class="text-timer">
      <span>{{ str }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['status'],
  data() {
    return {
      h: 0,
      m: 0,
      s: 0,
      ms: 0,
      time: 0, //定时器
      str: '00:00:00',
      times: '',
      isTimer: false
    }
  },
  computed: {
    btnText: function() {
      return this.isTimer ? '暂停' : '开始'
    }
  },
  watch: {
    status: function(newValue, oldValue) {
      if(newValue) {
        if(this.timer) this.reset()
        this.switchTimer()
      } else {
        this.switchTimer()
      }
    }
  },
  mounted() {
    // this.switchTimer()
  },
  methods: {
    switchTimer() {
      this.isTimer = !this.isTimer
      if(this.isTimer) {
        this.time = setInterval(this.timer, 50)
      } else {
        clearInterval(this.time)
        this.$emit('time', this.str, this.times)
      }
    },
    reset() {
      this.isTimer = false
      clearInterval(this.time)
      this.h = 0
      this.m = 0
      this.ms = 0
      this.s = 0
      this.str = '00:00:00'
    },
    timer() {
      this.ms = this.ms + 50
      if (this.ms >= 1000) {
        this.ms = 0
        this.s = this.s + 1
      }
      if (this.s >= 60) {
        this.s = 0
        this.m = this.m + 1
      }
      if (this.m >= 60) {
        this.m = 0
        this.h = this.h + 1
      }
      this.str = this.toDub(this.h) + ':' + this.toDub(this.m) + ':' + this.toDub(this.s)
      this.times = this.s + this.m * 60 + this.h * 3600
    },
    toDub(n) {
      if (n < 10) {
        return '0' + n
      } else {
        return '' + n
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .timer {
    display: flex;
    justify-content: center;
    align-items: center;
    .text-timer {
      margin: 0 10px;
      color: #A63528;
      font-family: JHuoCai;
    }
    .btn-timer {
      display: flex;
      align-items: center;
      border-left: 1px solid #cbc7c7;
      padding-left: 5px;
    }
  }
</style>